const echartColors = ['#5789ff', '#f90', '#7ED321'];

export const customerFlowOption = {
  title: {
    text: '',
    x: 'center',
    fontSize: 12,
  },
  color: echartColors,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999',
      },
    },
  },
  legend: {
    data: [], //图例，需要从后台获取并填写
    bottom: 10,
  },
  xAxis: [
    {
      type: 'category',
      data: [], //需要从后台获取并填写
      axisPointer: {
        type: 'shadow',
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
  ],
  yAxis: [
    {
      show: false,
      type: 'value',
      name: '',
      min: 0,
      /*max: 250,
      interval: 50,*/
      axisLabel: {
        formatter: '{value} ',
      },
    },
    {
      show: false,
      type: 'value',
      name: '',
      /*min: 0,
      max: 25,
      interval: 5,*/
      axisLabel: {
        formatter: '{value}',
      },
    },
  ],
  series: [],
};

/**
 * 柱状图单个数据的配置项
 */
export const barSeriesOption = {
  type: 'bar',
  barWidth: 10,
  itemStyle: {
    //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
    emphasis: {
      borderRadius: 30,
    },
    //柱形图圆角，初始化效果
    borderRadius: [10, 10, 10, 10],
  },
};

/**
 * 柱状图单个数据的配置项
 */
export const lineSeriesOption = {
  type: 'line',
  smooth: true,
};

/**
 * 客流排行
 */
export const customTopsOption = {
  color: echartColors,
  title: {
    text: '',
    x: 'center',
    textStyle: {
      fontSize: 12,
    },
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {
    data: [],
    show: false,
    bottom: 10,
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: [
    {
      type: 'value',
      show: false,
      boundaryGap: [0, 0.01],
    },
    {
      type: 'value',
      show: false,
      boundaryGap: [0, 0.01],
    },
  ],
  yAxis: [
    {
      type: 'category',
      data: [],
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      inverse: true,
    },
  ],
  series: [],
};

/**
 * 驾驶仓仪表盘option
 */
export const gaugeOption = {
  tooltip: {
    formatter: '{a} <br/>{b} : {c}%',
  },
  startAngle: 180, // 仪表盘起始角度,默认 225。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
  endAngle: 0,
  series: [
    {
      name: '业务指标',
      type: 'gauge',
      detail: { formatter: '{value}%' },
      data: [{ value: 50, name: '完成率' }],
    },
  ],
};
/**
 * 仪表盘数据项的配置
 */
export const gaugeSeriesOption = {
  name: '',
  type: 'gauge',
  min: 0,
  max: 100,
  radius: '100%',
  startAngle: 180,
  endAngle: 0,
  axisLine: {
    // 仪表盘轴线(轮廓线)相关配置。
    show: true, // 是否显示仪表盘轴线(轮廓线),默认 true。
    lineStyle: {
      // 仪表盘轴线样式。
      color: [
        [0.5, '#c23531'],
        [0.8, '#63869e'],
        [1, '#91c7ae'],
      ], //仪表盘的轴线可以被分成不同颜色的多段。每段的  结束位置(范围是[0,1]) 和  颜色  可以通过一个数组来表示。默认取值：[[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']]
      opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
      width: 20, //轴线宽度,默认 30。
      shadowBlur: 20, //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
      shadowColor: '#fff', //阴影颜色。支持的格式同color。
    },
  },
  splitLine: {
    // 分隔线样式。
    show: true, // 是否显示分隔线,默认 true。
    length: 20, // 分隔线线长。支持相对半径的百分比,默认 30。
    lineStyle: {
      // 分隔线样式。
      color: '#eee', //线的颜色,默认 #eee。
      opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
      width: 2, //线度,默认 2。
      type: 'solid', //线的类型,默认 solid。 此外还有 dashed,dotted
      shadowBlur: 10, //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
      shadowColor: '#fff', //阴影颜色。支持的格式同color。
    },
  },
  axisTick: {
    // 刻度(线)样式。
    show: true, // 是否显示刻度(线),默认 true。
    splitNumber: 5, // 分隔线之间分割的刻度数,默认 5。
    length: 8, // 刻度线长。支持相对半径的百分比,默认 8。
    lineStyle: {
      // 刻度线样式。
      color: '#eee', //线的颜色,默认 #eee。
      opacity: 1, //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
      width: 1, //线度,默认 1。
      type: 'solid', //线的类型,默认 solid。 此外还有 dashed,dotted
      shadowBlur: 10, //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
      shadowColor: '#fff', //阴影颜色。支持的格式同color。
    },
  },
  axisLabel: {
    // 刻度标签。
    show: false, // 是否显示标签,默认 true。
    distance: 5, // 标签与刻度线的距离,默认 5。
    color: '#fff', // 文字的颜色,默认 #fff。
    fontSize: 12, // 文字的字体大小,默认 5。
    formatter: '{value}', // 刻度标签的内容格式器，支持字符串模板和回调函数两种形式。 示例:// 使用字符串模板，模板变量为刻度默认标签 {value},如:formatter: '{value} kg'; // 使用函数模板，函数参数分别为刻度数值,如formatter: function (value) {return value + 'km/h';}
  },
  pointer: {
    // 仪表盘指针。
    show: true, // 是否显示指针,默认 true。
    length: '70%', // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
    width: 5, // 指针宽度,默认 8。
  },
  itemStyle: {
    // 仪表盘指针样式。
    color: 'auto', // 指针颜色，默认(auto)取数值所在的区间的颜色
    opacity: 1, // 图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
    borderWidth: 0, // 描边线宽,默认 0。为 0 时无描边。
    borderType: 'solid', // 柱条的描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'。
    borderColor: '#000', // 图形的描边颜色,默认 "#000"。支持的颜色格式同 color，不支持回调函数。
    shadowBlur: 10, // (发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
    shadowColor: '#fff', // 阴影颜色。支持的格式同color。
  },
  emphasis: {
    // 高亮的 仪表盘指针样式
    itemStyle: {
      //高亮 和正常  两者具有同样的配置项,只是在不同状态下配置项的值不同。
    },
  },
  title: {
    offsetCenter: [0, '80%'],
    fontSize: 13,
  },
  detail: {
    formatter: '{value}%',
    //color:''
  },
};
//代办单环状图
export const doughnutOption = {
  tooltip: {
    trigger: 'item',
    position: 'top',
  },
  color: echartColors,
  legend: {
    orient: 'vertical',
    x: 'left',
    y: 'center',
    left: '0',
    top: '24%',
    itemHeight: 12, //图例的高度
    itemWidth: 12,
    itemGap: 20,
    data: [],
  },
  series: [
    {
      name: '',
      type: 'pie',
      radius: ['70%', '80%'],
      avoidLabelOverlap: false,
      hoverOffset: 5,
      label: {
        normal: {
          show: false,
          position: 'center',
        },
        emphasis: {
          show: false,
          textStyle: {
            fontSize: '12',
            fontWeight: 'bold',
          },
        },
      },
      data: [],
    },
  ],
};
//数据中心双线图
export const doubleLineOption = {
  color: ['#FBA155', '#8AEDE0'],
  tooltip: {
    axisPointer: {
      type: 'cross',
    },
  },
  grid: {
    top: '20%',
  },
  legend: {
    data: [],
    bottom: 20,
    textStyle: {
      color: '#999999',
      fontSize: 14,
    },
  },
  xAxis: [
    {
      show: false,
      data: [],
    },
    {
      show: false,
      data: [],
    },
  ],
  yAxis: [{ show: false }],
  series: [
    {
      type: 'line',
      xAxisIndex: 1,
      smooth: true,
      symbol: 'none', //取消折点圆圈
      lineStyle: {
        color: '#FBA155', // 线条颜色
      },
    },
    {
      type: 'line',
      smooth: true,
      symbol: 'none', //取消折点圆圈
      lineStyle: {
        color: '#8AEDE0', // 线条颜色
      },
    },
  ],
};
//数据中心曲线图
export const lineOption = {
  color: echartColors,
  tooltip: {
    axisPointer: {
      type: 'cross',
    },
  },
  grid: {
    top: '25%',
  },
  legend: {
    data: [],
    bottom: 20,
  },
  xAxis: [
    {
      show: false,
      data: [],
    },
  ],
  yAxis: [{ show: false }],
  series: [
    {
      type: 'line',
      symbol: 'none', //取消折点圆圈
      smooth: true,
    },
  ],
};
